import * as React from 'react';

import type { ApolloError, ApolloQueryResult } from 'apollo-client';

import type { Notification } from 'bundles/notification-center/types';

import NotificationCenterMarkAllAsReadMutation from './NotificationCenterMarkAllAsReadMutation';
import NotificationCenterMarkAsReadMutation from './NotificationCenterMarkAsReadMutation';
import type {
  NotificationCenterMessagesQueryResponse,
  NotificationCenterMessagesQueryVariables,
} from './NotificationCenterMessagesQuery';
import NotificationCenterQueryProvider from './NotificationCenterQueryProvider';

export type NotificationCenterDataRenderProps = {
  loading?: boolean;
  error?: ApolloError;
  refetch: (
    variables?: NotificationCenterMessagesQueryVariables
  ) => Promise<ApolloQueryResult<NotificationCenterMessagesQueryResponse>>;
  notifications?: Notification[];
  markAllNotificationsAsRead: () => void;
  markNotificationAsRead: (id: string) => void;
};

type DataProviderProps = {
  children: (renderProps: NotificationCenterDataRenderProps) => React.ReactElement | null;
};

const NotificationCenterDataProvider = ({ children }: DataProviderProps) => (
  <NotificationCenterQueryProvider>
    {({ loading, error, refetch, notifications }) => (
      <NotificationCenterMarkAllAsReadMutation>
        {({ markAllNotificationsAsRead }) => (
          <NotificationCenterMarkAsReadMutation>
            {({ markNotificationAsRead }) =>
              children({
                loading,
                error,
                refetch,
                notifications,
                markNotificationAsRead,
                markAllNotificationsAsRead,
              })
            }
          </NotificationCenterMarkAsReadMutation>
        )}
      </NotificationCenterMarkAllAsReadMutation>
    )}
  </NotificationCenterQueryProvider>
);

export default NotificationCenterDataProvider;
